import { SupportedCountry } from '@/constants/country';
import type { CountryCode } from '@/constants/country';

const JP_POSTAL_CODE_REGEX = /^(\d{3})(\d+)$/;
/**
 * 指定された金額を通貨形式でフォーマットし、全角通貨記号(日本円のみ)を半角に変換します。
 *
 * @param {string} countryCode - 国コード（例: "JP", "ID"）
 * @param {string} postalCode - 郵便番号
 * @returns {string} フォーマットされた郵便番号
 * @example formatPostalCode("JP", "1234567") => "123-4567"
 */
export const formatPostalCode = (
  countryCode: CountryCode,
  postalCode: string,
): string => {
  switch (countryCode) {
    case SupportedCountry.JP:
      return postalCode.replace(JP_POSTAL_CODE_REGEX, '$1-$2');
    // 日本の他に変換するものがあれば
    default:
      return postalCode;
  }
};
